<form-control column-classes="col-md-2,col-md-5" labelKey="labelKey">
  <div ngbDropdown class="d-inline-block input-group-text">
    @if (displayDropDown) {
      <button
        class="btn btn-outline-primary"
        id="formArray"
        ngbDropdownToggle
        [appDisable]="readonly"></button>
      <div ngbDropdownMenu aria-labelledby="formArray">
        @for (control of formArray.controls; track control; let formArrayIndex = $index) {
          <button [formGroupName]="formArrayIndex" class="dropdown-item" ngbDropdownItem>
            {{ control | i18nText }}
          </button>
        }
      </div>
    }
  </div>
  <ng-container formGroupName="result">
    <input
      [type="text"
      formControlName="formControlNameInput"
      [appDisable]="readonly"
      maxlength="2000"
      [appDisable]="readonly" />
  </ng-container>
</form-control>
